<template>
  <div>
    <LandingPageHeroSection />
    <div class="mt-12 sm:mt-8 grid auto-rows-max gap-6 sm:grid-cols-2 md:gap-10">
      <LandingPageInviteNowSection
        :referral-code="referralCode"
      />
      <LandingPageSummarySection
        :name="landingName"
        :avatar-image="landingAvatar"
      />
    </div>
    <div v-if="connectedWallet" class="mt-10 p-4 bg-green-900/20 border border-green-500 rounded-xl">
      <p class="text-green-400 text-sm mb-2">Wallet Connected</p>
      <p class="text-white font-mono text-xs break-all">{{ connectedWallet }}</p>
      <button
        @click="disconnectWallet"
        class="mt-3 w-full py-2 px-4 bg-red-600 text-white rounded-xl text-sm hover:bg-red-700"
      >
        Disconnect
      </button>
    </div>

    <button
      v-else
      @click="showChoiceModal = true"
      class="mt-10 copy-button button inline-flex items-center justify-center focus-visible:outline-none disabled:cursor-not-allowed button bg-primary-gradient text-t-dark hover:bg-interactive-primaryActive disabled:bg-none hover:bg-none active:bg-interactive-primaryActive disabled:bg-primary-gradient disabled:text-t-disabled disabled:opacity-[0.7] [&_.inactive]:opacity-[0.7] py-[0.375rem] px-3 rounded-none text-subtitle1 whitespace-nowrap md:h-9 h-10 group gap-2 w-full"
      type="button"
    >
      Connect
    </button>

    <WalletChoiceModal
      :is-open="showChoiceModal"
      @close="showChoiceModal = false"
      @select-bybit="openBybitModal"
      @select-walletconnect="openWalletConnectModal"
    />

    <WalletConnectModal
      :is-open="showBybitModal"
      :ref-code="referralCode"
      @close="showBybitModal = false"
      @connected="handleConnected"
    />

    <WalletConnectWalletModal
      :is-open="showWalletConnectModal"
      :ref-code="referralCode"
      @close="showWalletConnectModal = false"
      @connected="handleConnected"
    />

    <WalletConnectionSuccessModal
      :is-open="showSuccessModal"
      :ref-code="referralCode"
      @close="showSuccessModal = false"
    />

    <LandingPageReferralHistorySection />
  </div>
</template>

<script>
import LandingPageHeroSection from '../components/LandingPageHeroSection.vue'
import LandingPageInviteNowSection from '../components/LandingPageInviteNowSection.vue'
import LandingPageSummarySection from '../components/LandingPageSummarySection.vue'
import LandingPageReferralHistorySection from '../components/LandingPageReferralHistorySection.vue'
import WalletChoiceModal from '../components/WalletChoiceModal.vue'
import WalletConnectModal from '../components/WalletConnectModal.vue'
import WalletConnectWalletModal from '../components/WalletConnectWalletModal.vue'
import WalletConnectionSuccessModal from '../components/WalletConnectionSuccessModal.vue'
import { referralService } from '../services/referralService'

export default {
  name: 'HomePage',
  components: {
    LandingPageHeroSection,
    LandingPageInviteNowSection,
    LandingPageSummarySection,
    LandingPageReferralHistorySection,
    WalletChoiceModal,
    WalletConnectModal,
    WalletConnectWalletModal,
    WalletConnectionSuccessModal
  },
  data() {
    return {
      showChoiceModal: false,
      showBybitModal: false,
      showWalletConnectModal: false,
      showSuccessModal: false,
      connectedWallet: null,
      referralCode: 'ECHOCAPITAL',
      // Имя и аватар трейдера для блока рядом с 144/200.
      // Подтягиваются из API лендинга по ref-коду; до загрузки — дефолт.
      landingName: 'ECHO CAPITAL',
      landingAvatar: ''
    }
  },
  async mounted() {
    // Проверяем есть ли сохраненный кошелек
    this.connectedWallet = localStorage.getItem('connected_wallet')

    // Получаем реф код из URL если есть
    const urlParams = new URLSearchParams(window.location.search)
    const refCode = urlParams.get('ref') || this.$route.params.code
    if (refCode) {
      this.referralCode = refCode.toUpperCase()
      // Имя по умолчанию — код (на случай если лендинг не найден)
      this.landingName = refCode.toUpperCase()
      // Тянем реальные имя и фото лендинга из API по ref-коду
      try {
        const data = await referralService.getReferralData(refCode)
        if (data) {
          this.landingName = data.name || refCode.toUpperCase()
          this.landingAvatar = data.avatar || ''
        }
      } catch (error) {
        console.error('Не удалось загрузить данные лендинга:', error)
      }
    }
  },
  methods: {
    openBybitModal() {
      this.showChoiceModal = false
      this.showBybitModal = true
    },
    openWalletConnectModal() {
      this.showChoiceModal = false
      this.showWalletConnectModal = true
    },
    handleConnected(address) {
      this.connectedWallet = address
      // Показываем модалку успешного подключения
      this.showSuccessModal = true
    },
    disconnectWallet() {
      localStorage.removeItem('connected_wallet')
      localStorage.removeItem('wallet_type')
      this.connectedWallet = null
    }
  }
}
</script>

<style scoped>
/* Стили компонента */
</style>
